export default "__VITE_ASSET__BSv7n9iY__"